import {Injectable} from '@angular/core';
import {HttpService} from '../../shared/services/http.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseResponse} from '../../shared/models/respose/BaseResponse';
import {Tag} from '../../shared/models/Tag';
import {Order} from '../../shared/models/Order';
import {PaginatedDataResponse} from '../../shared/models/respose/PaginatedDataResponse';
import {PaginatedDataRequest} from '../../shared/models/request/PaginatedDataRequest';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TagService extends HttpService {

  getAll(): Observable<BaseResponse<Tag[]>>{
    return this.get('tags');
  }

  getAllByCourse(courseId: number): Observable<BaseResponse<Tag[]>>{
    return this.get('tags/course/' + courseId);
  }

  getPaginatedList(entries: number,
                   page: number,
                   data?: Tag,
                   order?: Order): Observable<BaseResponse<PaginatedDataResponse<Tag>>>{
    const request = new PaginatedDataRequest<Tag>(entries, page, data, order);
    return this.post('tags', request).pipe(
      map(response => {
        return response;
      })
    );
  }

  register(request: Tag): Observable<BaseResponse<Tag>>{
    return this.post('tags/store', request);
  }

  deleteItem(id: number): Observable<BaseResponse<Tag>>{
    return this.delete('tags', id);
  }

  updateItem(request: Tag, id: number): Observable<BaseResponse<Tag>>{
    return this.put('tags', request, id);
  }
}
